import { CircularProgress, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { SPACING } from "helpers/spacings";
import { ContentCopy, Download, ShareVariant } from "mdi-material-ui";
import React, { useState } from "react";

import PlayerButton from "./PlayerButton";

// Mobile's share button where there's no share sheet (http, Firefox, the Android app), popping up copy link and download.
// onOpen: download needs the whole video file, so the player fetches it once the menu first opens
// onCopyLink and onDownload: left out where they aren't available, eg the clipboard on http, or download in the app
export default function ShareMenuButton({ color, fileReady, onOpen, onCopyLink, onDownload }) {
  const [anchorEl, anchorElSet] = useState(null);

  const item = (label, icon, onClick, needsFile) => (
    <MenuItem
      disabled={needsFile && !fileReady}
      onClick={() => {
        anchorElSet(null);
        onClick();
      }}
    >
      <ListItemIcon>{icon}</ListItemIcon>
      {label}
      {needsFile && !fileReady && (
        // still fetching the file
        <span style={{ display: "flex", marginLeft: "auto", paddingLeft: SPACING }}>
          <CircularProgress size={14} color="inherit" />
        </span>
      )}
    </MenuItem>
  );

  return (
    <>
      <PlayerButton
        title="Share"
        color={color}
        icon={<ShareVariant />}
        onClick={(event) => {
          anchorElSet(event.currentTarget);
          onOpen?.();
        }}
      />
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => anchorElSet(null)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        {onCopyLink && item("Copy link", <ContentCopy fontSize="small" />, onCopyLink, false)}
        {onDownload && item("Download", <Download fontSize="small" />, onDownload, true)}
      </Menu>
    </>
  );
}
